import { useContext, useState } from 'react'

import AppContext from '@/common/context/app.context'
import { dashboardViewTypes } from '@/metrics/pages/DashboardPage/constants'

const useViewType = isUnifiedDashboard => {
  const { info } = useContext(AppContext)
  const [viewType, setViewType] = useState(dashboardViewTypes.returns)

  const showViewTypeSelector = info?.selectedStore?.preferences?.allows_shipments && !isUnifiedDashboard

  return { viewType, setViewType, showViewTypeSelector }
}

export default useViewType
